module.exports = __webpack_public_path__ + "static/img/summary_c.bf3208bb.png";